webpackJsonp([17],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUrl = 'https://www.sub2u.com/api';
// const baseUrl = 'https://subway.forecepts.net/api'
// const baseUrl = 'http://192.168.3.250/'

var home = '/Home/GetHomeInfos';
var faq = '/Faq/GetFaqs';
var contactUs = '/Common/ContactUs';
var address = 'https://www.onemap.gov.sg/api/common/elastic/search';

var login = '/Account/Login';
var signup = '/Account/SignUp';
var register = '/Account/Register';
var forgotPassword = '/Account/ForgotPassword';
var forgotPasswordCheck = '/Account/ForgotPasswordCheckValidateCode';
var resendEmail = '/Account/RegisterReSendEmail';
var validateCode = '/Account/CheckValidateCode';
var logout = '/Account/Logout';
var category = '/Category/GetCategories';
var outlet = '/Outlet/GetOutlets';
var product = '/Product/GetProducts';
var productDetail = '/Product/GetProductDetail';

var carts = '/Cart/GetCartDetail';
var cartPreAdd = '/Cart/PreAdd';
var cartAddNew = '/Cart/AddNew';
var cartAdd = '/Cart/Add';
var cartRemove = '/Cart/Remove';
var cartEdit = '/Cart/Edit';
var cartCheckout = '/Cart/Checkout';
var cartChangeDelivery = '/Cart/ChangeDeliveryType';

var orderCheckoutInfo = '/Order/GetCheckoutInfo';
var orderDetail = '/Order/GetOrderDetail';
var orderApplyVoucher = '/Order/ApplyVoucher';
var orderComplete = '/Order/CompleteOrder';
var orderThankyou = '/Order/GetThankYou';
var orderGetPaging = '/Order/GetOrdersPaging';
var orderRemove = '/Order/RemoveOrder';
var orderUpdateDelivery = '/Order/ChangeDeliveryDate';

var customerAddresses = '/Customer/GetAddresses';
var customerAddAddress = '/Customer/AddAddress';
var customerEditAddress = '/Customer/EditAddress';
var customerRemoveAddress = '/Customer/RemoveAddress';
var customerGetInfo = '/Customer/GetCustomerInfo';
var customerEditInfo = '/Customer/EditCustomerInfo';
var customerEditPassword = '/Customer/ChanagePassword';
var customerCredit = '/Customer/GetMyCredit';
var customerPointsPaging = '/Customer/GetPointsPaging';

/* harmony default export */ __webpack_exports__["a"] = ({
  baseUrl: baseUrl,
  home: home,
  faq: faq,
  contactUs: contactUs,
  address: address,
  login: login,
  signup: signup,
  resendEmail: resendEmail,
  validateCode: validateCode,
  logout: logout,
  register: register,
  forgotPassword: forgotPassword,
  forgotPasswordCheck: forgotPasswordCheck,
  category: category,
  outlet: outlet,
  // product
  product: product,
  productDetail: productDetail,
  // cart
  carts: carts,
  cartPreAdd: cartPreAdd,
  cartAddNew: cartAddNew,
  cartAdd: cartAdd,
  cartRemove: cartRemove,
  cartEdit: cartEdit,
  cartCheckout: cartCheckout,
  cartChangeDelivery: cartChangeDelivery,
  // customer
  customerAddresses: customerAddresses,
  customerAddAddress: customerAddAddress,
  customerEditAddress: customerEditAddress,
  customerRemoveAddress: customerRemoveAddress,
  customerGetInfo: customerGetInfo,
  customerEditInfo: customerEditInfo,
  customerEditPassword: customerEditPassword,
  customerCredit: customerCredit,
  customerPointsPaging: customerPointsPaging,
  // order
  orderCheckoutInfo: orderCheckoutInfo,
  orderDetail: orderDetail,
  orderApplyVoucher: orderApplyVoucher,
  orderComplete: orderComplete,
  orderThankyou: orderThankyou,
  orderGetPaging: orderGetPaging,
  orderRemove: orderRemove,
  orderUpdateDelivery: orderUpdateDelivery
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageScroll_ScrollToTop__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_checkout_Cart__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_click_outside__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_checkout_PickupOrDelivery__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Loading__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  // asyncData ({ store }) {
  //   return store.dispatch('category/getCategory')
  // },
  name: 'app',
  components: {
    'scroll-top': __WEBPACK_IMPORTED_MODULE_3__components_PageScroll_ScrollToTop__["a" /* default */],
    'fc-login': __WEBPACK_IMPORTED_MODULE_4__components_Login__["a" /* default */],
    'fc-cart': __WEBPACK_IMPORTED_MODULE_5__components_checkout_Cart__["a" /* default */],
    'loading': __WEBPACK_IMPORTED_MODULE_8__components_common_Loading__["a" /* default */],
    'pickup-or-delivery': __WEBPACK_IMPORTED_MODULE_7__components_checkout_PickupOrDelivery__["a" /* default */]
  },
  created: function created() {
    this.$store.dispatch('category/getCategory');
    this.$store.dispatch('cart/generateTokenId');
    this.$store.dispatch('profileLogin/checkLogin');

    if (process.browser) {
      var _this = this;
      var sessionStorageTransfer = function sessionStorageTransfer(event) {
        if (!event) {
          event = window.event;
        }
        if (!event.newValue) return;
        if (event.key === 'getSessionStorage') {
          localStorage.setItem('sessionStorage', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sessionStorage));
          localStorage.removeItem('sessionStorage');
        } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
          var data = JSON.parse(event.newValue);
          for (var key in data) {
            sessionStorage.setItem(key, data[key]);
          }
          _this.$store.dispatch('profileLogin/checkLogin');
        }
      };

      if (window.addEventListener) {
        window.addEventListener('storage', sessionStorageTransfer, false);
      } else {
        window.attachEvent('onstorage', sessionStorageTransfer);
      }
      if (!sessionStorage.length) {
        localStorage.setItem('getSessionStorage', 'foobar');
        localStorage.removeItem('getSessionStorage', 'foobar');
      }
    }
  },
  data: function data() {
    return {
      isMobileMenuActive: false,
      showlogin: false,
      showUserControl: false
    };
  },

  methods: {
    closeUserControl: function closeUserControl() {
      this.showUserControl = false;
      this.isMobileMenuActive = false;
    },
    myOrders: function myOrders() {
      this.showUserControl = false;
      this.isMobileMenuActive = false;
      this.$router.push(this.RouterConfig.MyOrders);
    },
    myInformation: function myInformation() {
      this.showUserControl = false;
      this.isMobileMenuActive = false;
      this.$router.push(this.RouterConfig.MyInformation);
    },
    myCredit: function myCredit() {
      this.showUserControl = false;
      this.isMobileMenuActive = false;
      this.$router.push(this.RouterConfig.MyCredit);
    },
    ourLocation: function ourLocation() {
      this.isMobileMenuActive = false;
      this.$router.push(this.RouterConfig.OurLocation);
    },
    logout: function logout() {
      var _this = this;
      if (process.browser) {
        __WEBPACK_IMPORTED_MODULE_9_jquery___default.a.confirm({
          title: 'Warning',
          content: 'Logout?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function action() {
                _this.$store.dispatch('profileLogin/logout').then(function () {
                  _this.$router.push(_this.RouterConfig.Home);
                });
              }
            },
            close: function close() {}
          }
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('profileLogin', ['loginInfo']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('category', ['categoryList']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('cart', ['isFirstItem'])),
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_6_vue_click_outside___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toTopShow: false
    };
  },

  methods: {
    handleScroll: function handleScroll() {
      if (process.browser) {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.toTopShow = this.scrollTop > 300;
      }
    },
    scrollToTop: function scrollToTop() {
      var timer = null;
      var _this = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_this.scrollTop > 0) {
          _this.scrollTop -= 50;
          document.documentElement.scrollTop = document.body.scrollTop = _this.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _this.toTopShow = false;
        }
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.handleScroll);
    });
  },
  destoryed: function destoryed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_facebook_login_vuejs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_facebook_login_vuejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_facebook_login_vuejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-login',
  components: {
    facebookLogin: __WEBPACK_IMPORTED_MODULE_0_facebook_login_vuejs___default.a
  },
  data: function data() {
    return {
      username: '',
      password: '',
      FB: undefined,
      googleSignInParams: {
        client_id: '926155119395-v9n8h468qje8bp49b9rkd405r084fck5.apps.googleusercontent.com'
      }
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      if (this.username === '' || this.password === '') {
        if (process.browser) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.alert({
            title: 'Notice',
            content: 'Please input your email or password',
            type: 'orange',
            useBootstrap: false
          });
        }
        return;
      }
      var params = {
        Email: this.username,
        Password: this.password
      };
      this.$store.dispatch('profileLogin/login', params).then(function (a) {
        _this.$emit('closelogin');
        if (_this.$route.path === _this.RouterConfig.ForgotPassword) {
          _this.$router.push(_this.RouterConfig.Home);
        }
      }).catch(function () {});
    },
    register: function register() {
      this.$emit('closelogin');
      this.$router.push({ path: this.RouterConfig.Register });
    },
    forgotpassword: function forgotpassword() {
      this.$emit('closelogin');
      this.$router.push({ path: this.RouterConfig.ForgotPassword });
    },

    close: function close() {
      this.$emit('closelogin');
    },
    loginWithFB: function loginWithFB() {
      this.getFBUser();
    },
    fbLoaded: function fbLoaded(payload) {
      this.FB = payload.FB;
      if (payload.isConnected) {
        this.FB.logout();
      }
    },
    getFBUser: function getFBUser() {
      var _this2 = this;

      this.FB.api('/me', 'GET', { fields: 'id,name,email' }, function (userInformation) {
        var data = {
          OpenId: userInformation.id,
          From: 1,
          Avatar: '',
          Email: userInformation.email,
          Name: userInformation.name
        };
        _this2.signup(data);
      });
    },
    onSignInSuccess: function onSignInSuccess(googleUser) {
      var profile = googleUser.getBasicProfile();
      var data = {
        OpenId: profile.getId(),
        From: 2,
        Avatar: profile.getImageUrl(),
        Email: profile.getEmail(),
        Name: profile.getName()
      };
      this.signup(data);
    },
    onSignInError: function onSignInError() {},
    signup: function signup(data) {
      var _this3 = this;

      this.$store.dispatch('profileLogin/signup', data).then(function (a) {
        _this3.$emit('closelogin');
        if (_this3.$route.path === _this3.RouterConfig.ForgotPassword) {
          _this3.$router.push(_this3.RouterConfig.Home);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_click_outside__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cart',
  data: function data() {
    return {
      showCart: false
    };
  },
  created: function created() {
    this.$store.dispatch('cart/getCarts');
  },

  methods: {
    toCartDetail: function toCartDetail() {
      this.showCart = false;
      this.$router.push({ path: this.RouterConfig.CartDetail });
    },
    hideCartList: function hideCartList() {
      this.showCart = false;
    },
    remove: function remove(product) {
      if (process.browser) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.confirm({
          title: 'Warning',
          content: 'Remove this item?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function action() {
                _this.$store.dispatch('cart/removeCartProduct', product);
              }
            },
            close: function close() {}
          }
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["b" /* mapFields */])('cart', ['items']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["c" /* mapMultiRowFields */])('cart', {
    cartsProducts: 'items.CartsProducts'
  }), {
    statusPercent: function statusPercent() {
      if (this.items.SubTotal < this.items.MinimumPurchaseForDelivery) {
        return (this.items.SubTotal / this.items.MinimumPurchaseForDelivery * 100).toString() + '%';
      } else if (this.items.SubTotal < this.items.FreeDeliveryPurchaseAmount) {
        return (this.items.SubTotal / this.items.FreeDeliveryPurchaseAmount * 100).toString() + '%';
      } else {
        return '100%';
      }
    },
    enableCheckout: function enableCheckout() {
      return this.items.SubTotal >= this.items.MinimumPurchaseForDelivery || this.items.DeliveryType === 0;
    }
  }),
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_2_vue_click_outside___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_flatpickr_component__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import $ from 'jquery'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    flatPickr: __WEBPACK_IMPORTED_MODULE_3_vue_flatpickr_component___default.a
  },
  data: function data() {
    return {
      tabIndex: 0,
      selectedOutletId: 0,
      deliverAddress: {
        postalCode: '',
        unitNo: '',
        address: ''
      },
      hasPickupError: false,
      hasError: false,
      pickupDateDate: null,
      pickupDateTime: null
    };
  },

  methods: {
    dayCreate: function dayCreate(dObj, dStr, fp, dayElem) {
      if (dStr === '') {
        var td = this.tabIndex === 1 ? this.pickupMinDate : this.deliveryMinDate;
        var hour = td.getHours() < 10 ? '0' + td.getHours() : '' + td.getHours();
        var minute = td.getMinutes() < 10 ? '0' + td.getMinutes() : '' + td.getMinutes();
        this.pickupDateTime = hour + ':' + minute;
        return false;
      }
    },

    selectDeliver: function selectDeliver() {
      var _this = this;

      var time = this.pickupDateTime === null || this.pickupDateTime === '' ? '12:00' : this.pickupDateTime;
      var data = {
        DeliveryType: this.tabIndex - 1,
        PostalCode: this.deliverAddress.postalCode,
        DeliveryDateTime: this.pickupDateDate + ' ' + time + ':00',
        DeliveryAddress: this.address.ADDRESS,
        OutletId: this.selectedOutletId
      };
      this.$store.dispatch('cart/addNewCart', data).then(function () {
        _this.$store.dispatch('cart/noneFirstItem', false);
      });
    },
    getAddress: function getAddress() {
      this.$store.dispatch('address/getAddress', this.deliverAddress.postalCode);
    },
    selectOutlet: function selectOutlet() {
      var pc = this.deliverAddress.postalCode;
      if (pc === '' || pc.length !== 6 || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        if (process.browser) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert({
            title: 'Notice',
            content: 'Invalid postal code',
            type: 'red',
            useBootstrap: false
          });
        }
        return;
      }
      var preCode = pc.toString().substring(0, 2);
      if (this.preAdd.NoDeliveryLocations != null && this.preAdd.NoDeliveryLocations.indexOf(preCode) >= 0) {
        if (process.browser) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert({
            title: 'Notice',
            content: 'Sorry, this postal code is not in our delivery locations',
            type: 'red',
            useBootstrap: false
          });
        }
        return;
      }
      var o = this.preAdd.Outlets.filter(function (a) {
        return a.DeliveryPostalZones.indexOf(preCode) >= 0;
      });
      if (o.length > 0) {
        this.selectedOutletId = o[0].OutletId;
      } else {
        if (process.browser) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert({
            title: 'Notice',
            content: 'There is no outlet for your postal code',
            type: 'red',
            useBootstrap: false
          });
        }
      }
    },

    close: function close() {
      this.$store.dispatch('cart/noneFirstItem', false);
    },
    getEndDate: function getEndDate(d, o) {
      if (d.getDay() === 0) {
        return o.OperatingHoursSunEnd;
      } else if (d.getDay() === 1) {
        return o.OperatingHoursMonEnd;
      } else if (d.getDay() === 2) {
        return o.OperatingHoursTuesEnd;
      } else if (d.getDay() === 3) {
        return o.OperatingHoursWedEnd;
      } else if (d.getDay() === 4) {
        return o.OperatingHoursThurEnd;
      } else if (d.getDay() === 5) {
        return o.OperatingHoursFriEnd;
      } else if (d.getDay() === 6) {
        return o.OperatingHoursSatEnd;
      } else {
        return '12';
      }
    },
    getFromDate: function getFromDate(d, o) {
      if (d.getDay() === 0) {
        return o.OperatingHoursSunFrom;
      } else if (d.getDay() === 1) {
        return o.OperatingHoursMonFrom;
      } else if (d.getDay() === 2) {
        return o.OperatingHoursTuesFrom;
      } else if (d.getDay() === 3) {
        return o.OperatingHoursWedFrom;
      } else if (d.getDay() === 4) {
        return o.OperatingHoursThurFrom;
      } else if (d.getDay() === 5) {
        return o.OperatingHoursFriFrom;
      } else if (d.getDay() === 6) {
        return o.OperatingHoursSatFrom;
      } else {
        return '12';
      }
    },
    getPickupDate: function getPickupDate() {
      var today = new Date();
      var hour = today.getHours() < 10 ? '0' + today.getHours() : '' + today.getHours();
      var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : '' + today.getMinutes();
      var ds = (this.pickupDateFormat + ' ' + hour + ':' + minute + ':00').replace(/-/g, '/');
      return new Date(ds);
    },
    getPickupDateMonth: function getPickupDateMonth() {
      var today = this.getPickupDate();
      return today.getMonth() < 10 ? '0' + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString();
    },
    getCurrentDateWithoutSec: function getCurrentDateWithoutSec() {
      var today = new Date();
      var hour = today.getHours() < 10 ? '0' + today.getHours() : '' + today.getHours();
      var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : '' + today.getMinutes();
      var month = today.getMonth() < 10 ? '0' + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString();
      var mindate = new Date(today.getFullYear() + '/' + month + '/' + today.getDate() + ' ' + hour + ':' + minute + ':00');
      return mindate;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__["b" /* mapFields */])('cart', ['items', 'preAdd']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('address', ['address']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('cart', ['isFirstItem']), {
    pickupEnable: function pickupEnable() {
      if (this.tabIndex === 1 && this.selectedOutletId > 0 && this.pickupDateFormat !== null && this.pickupDateFormat !== '' && this.pickupDateTime !== null && this.pickupDateTime !== '') {
        var pickupDate = new Date(this.pickupDateFormat + ' ' + this.pickupDateTime + ':00').getTime();
        if (this.pickupMinDate === null || this.pickupMaxDate === null) {
          return false;
        }
        var canPickup = pickupDate >= this.pickupMinDate.getTime() - 60 * 1000 && pickupDate <= this.pickupMaxDate.getTime();
        if (canPickup) {
          this.hasPickupError = false;
          return true;
        } else {
          this.hasPickupError = true;
          return false;
        }
      }
      return false;
    },
    pickupMinDate: function pickupMinDate() {
      var _this2 = this;

      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date();
      }

      var o = this.preAdd.Outlets.filter(function (a) {
        return _this2.selectedOutletId === a.OutletId;
      });
      if (o.length > 0) {
        var selectedPickupDate = new Date(this.pickupDateFormat + ' 00:00:00');
        var mindate = new Date(new Date().getTime() + this.preAdd.SelfPickupMins * 1000 * 60);
        var hour = this.getFromDate(selectedPickupDate, o[0]);
        if (hour === null) {
          return null;
        }
        var endTime = new Date(new Date(this.pickupDateFormat + ' ' + hour + ':00').getTime() + 2 * 60 * 60 * 1000);
        return endTime.getTime() > mindate.getTime() ? endTime : mindate;
      }
      return new Date();
    },
    pickupMaxDate: function pickupMaxDate() {
      var _this3 = this;

      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date();
      }
      var o = this.preAdd.Outlets.filter(function (a) {
        return _this3.selectedOutletId === a.OutletId;
      });
      if (o.length > 0) {
        var today = new Date(this.pickupDateFormat + ' 00:00:00');
        var hour = this.getEndDate(today, o[0]);
        if (hour === null) {
          return null;
        }
        var endTime = this.pickupDateFormat + ' ' + hour + ':00';
        return new Date(endTime);
      }
      return new Date();
    },
    deliveryEnable: function deliveryEnable() {
      if (this.tabIndex === 2 && this.pickupDateFormat !== null && this.pickupDateFormat !== '' && this.deliverAddress.postalCode !== '' && this.deliverAddress.postalCode.length === 6 && this.pickupDateTime !== null && this.pickupDateTime !== '') {
        var pickupDate = new Date(this.pickupDateFormat + ' ' + this.pickupDateTime + ':00').getTime();
        var canDelivery = pickupDate >= this.deliveryMinDate.getTime() - 60 * 1000 && pickupDate <= this.deliveryMaxDate.getTime();
        if (this.deliveryMinDate !== null && this.deliveryMaxDate !== null && canDelivery) {
          this.hasError = false;
          return true;
        } else {
          return this.deliveryEnableReplace;
        }
      }
      return false;
    },
    deliveryEnableReplace: function deliveryEnableReplace() {
      if (this.tabIndex === 2 && this.pickupDateFormat !== null && this.pickupDateFormat !== '' && this.deliverAddress.postalCode !== '' && this.deliverAddress.postalCode.length === 6 && this.pickupDateTime !== null && this.pickupDateTime !== '') {
        var pickupDate = new Date(this.pickupDateFormat + ' ' + this.pickupDateTime + ':00').getTime();
        if (this.deliveryMinDateReplace === null || this.deliveryMaxDateReplace === null) {
          return false;
        }
        var canDelivery = pickupDate >= this.deliveryMinDateReplace.getTime() && pickupDate <= this.deliveryMaxDateReplace.getTime();
        if (canDelivery) {
          this.hasError = false;
          return true;
        } else {
          this.hasError = true;
          return false;
        }
      }
      return false;
    },
    deliveryMinDate: function deliveryMinDate() {
      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date();
      }
      var today = new Date(this.pickupDateFormat + ' 00:00:00'); // this.getPickupDate()
      // const mindate = new Date(this.getCurrentDateWithoutSec().getTime() + this.preAdd.DeliveryMins * 1000 * 60)
      var mindate = new Date(new Date().getTime() + this.preAdd.DeliveryMins * 1000 * 60);

      var pc = this.deliverAddress.postalCode;
      if (pc === '' || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        return mindate;
      }
      var preCode = pc.toString().substring(0, 2);
      var o = this.preAdd.Outlets.filter(function (a) {
        return a.DeliveryPostalZones.indexOf(preCode) >= 0;
      });
      if (o.length > 0) {
        this.selectedOutletId = o[0].OutletId;
        // const month = this.getPickupDateMonth()
        var hour = this.getFromDate(today, o[0]);
        if (hour === null) {
          return null;
        }
        var endTime = new Date(new Date(this.pickupDateFormat + ' ' + hour + ':00').getTime() + 2 * 60 * 60 * 1000);
        return endTime.getTime() > mindate.getTime() ? endTime : mindate;
      }
      return mindate;
    },

    deliveryMinDateReplace: {
      get: function get() {
        if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
          return new Date();
        }
        var today = new Date(this.pickupDateFormat + ' 00:00:00'); // this.getPickupDate()
        // const mindate = new Date(this.getCurrentDateWithoutSec().getTime() + this.preAdd.DeliveryMins * 1000 * 60)
        var mindate = new Date(new Date().getTime() + this.preAdd.DeliveryMins * 1000 * 60);

        var pc = this.deliverAddress.postalCode;
        if (pc === '' || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
          return mindate;
        }
        var preCode = pc.toString().substring(0, 2);
        var to = this.preAdd.Outlets.filter(function (a) {
          return a.DeliveryPostalZones.indexOf(preCode) >= 0;
        });
        if (to.length < 1) {
          return new Date();
        }
        var o = this.preAdd.Outlets.filter(function (a) {
          return a.OutletId === to[0].ReplacementOutletId;
        });
        if (o.length > 0) {
          this.selectedOutletId = o[0].OutletId;
          // const month = this.getPickupDateMonth()
          var hour = this.getFromDate(today, o[0]);
          if (hour === null) {
            return null;
          }
          var endTime = new Date(new Date(this.pickupDateFormat + ' ' + hour + ':00').getTime() + 2 * 60 * 60 * 1000);
          var theMinDate = endTime.getTime() > mindate.getTime() ? endTime : mindate;
          return theMinDate;
        }
        return mindate;
      },
      set: function set() {
        if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
          return new Date();
        }
        var pc = this.deliverAddress.postalCode;
        if (pc !== '' && !isNaN(parseInt(pc)) && parseInt(pc) > 10) {
          var preCode = pc.toString().substring(0, 2);
          var to = this.preAdd.Outlets.filter(function (a) {
            return a.DeliveryPostalZones.indexOf(preCode) >= 0;
          });
          if (to.length > 0) {
            var o = this.preAdd.Outlets.filter(function (a) {
              return a.OutletId === to[0].ReplacementOutletId;
            });
            if (o.length > 0) {
              this.selectedOutletId = o[0].OutletId;
            }
          }
        }
      }
    },
    deliveryMaxDate: function deliveryMaxDate() {
      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date();
      }
      var pc = this.deliverAddress.postalCode;
      if (pc === '' || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        return new Date();
      }
      var preCode = pc.toString().substring(0, 2);
      var o = this.preAdd.Outlets.filter(function (a) {
        return a.DeliveryPostalZones.indexOf(preCode) >= 0;
      });
      if (o.length > 0) {
        var today = this.getPickupDate();
        var month = this.getPickupDateMonth();
        var hour = this.getEndDate(today, o[0]);
        if (hour === null) {
          return null;
        }
        var endTime = today.getFullYear() + '/' + month + '/' + today.getDate() + ' ' + hour + ':00';
        return new Date(endTime);
      }
      return new Date();
    },
    deliveryMaxDateReplace: function deliveryMaxDateReplace() {
      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date();
      }
      var pc = this.deliverAddress.postalCode;
      if (pc === '' || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        return new Date();
      }
      var preCode = pc.toString().substring(0, 2);
      var to = this.preAdd.Outlets.filter(function (a) {
        return a.DeliveryPostalZones.indexOf(preCode) >= 0;
      });
      if (to.length < 1) {
        return new Date();
      }
      var o = this.preAdd.Outlets.filter(function (a) {
        return a.OutletId === to[0].ReplacementOutletId;
      });
      if (o.length > 0) {
        var today = this.getPickupDate();
        var month = this.getPickupDateMonth();
        var hour = this.getEndDate(today, o[0]);
        if (hour === null) {
          return null;
        }
        var endTime = today.getFullYear() + '/' + month + '/' + today.getDate() + ' ' + hour + ':00';
        return new Date(endTime);
      }
      return new Date();
    },
    pickupDateFormat: function pickupDateFormat() {
      if (this.pickupDateDate === null) {
        return '';
      }
      return this.pickupDateDate.replace(/-/g, '/');
    }
  }),
  destroy: function destroy() {
    this.$store.dispatch('cart/noneFirstItem', false);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Home = '/';

// const ComboPackage = '/combopackage'
// const Sandwiches = '/sandwiches'
// const Lunchboxes = '/lunchboxes'
// const Drinks = '/drinks'
// const Cookies = '/cookies'

var CartDetail = '/cart';
var Checkout = '/checkout';
var Register = '/register';
var ForgotPassword = '/forgot-password';
var GiantSub = '/giantsub';
var CheckoutSuccess = '/thankyou';
var OurLocation = '/location';
var ContactUs = '/contact-us';
var FAQ = '/faq';
var UserTerm = '/terms';
var PrivacyPolicy = '/privacy-policy';
// profile
var MyOrders = '/orders';
var MyOrderDetail = '/order-detail';
var MyCredit = '/credit';
var MyInformation = '/myinfo';

/* harmony default export */ __webpack_exports__["a"] = ({
  Home: Home,
  // ComboPackage,
  // Sandwiches,
  // Lunchboxes,
  // Drinks,
  // Cookies,
  CartDetail: CartDetail,
  Checkout: Checkout,
  Register: Register,
  ForgotPassword: ForgotPassword,
  GiantSub: GiantSub,
  CheckoutSuccess: CheckoutSuccess,
  OurLocation: OurLocation,
  ContactUs: ContactUs,
  FAQ: FAQ,
  UserTerm: UserTerm,
  PrivacyPolicy: PrivacyPolicy,
  // profile
  MyOrders: MyOrders,
  MyOrderDetail: MyOrderDetail,
  MyCredit: MyCredit,
  MyInformation: MyInformation
});

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28810223_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(124);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28810223_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(111);




var _CreateApp = Object(__WEBPACK_IMPORTED_MODULE_2__main__["a" /* CreateApp */])(),
    app = _CreateApp.app,
    router = _CreateApp.router,
    store = _CreateApp.store;

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__);
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
  beforeMount: function beforeMount() {
    var asyncData = this.$options.asyncData;

    if (asyncData) {
      // 将获取数据操作分配给 promise
      // 以便在组件中，我们可以在数据准备就绪后
      // 通过运行 `this.dataPromise.then(...)` 来执行其他任务
      this.dataPromise = asyncData({
        store: this.$store,
        route: this.$route
      });
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var asyncData = this.$options.asyncData;

    if (asyncData) {
      asyncData({
        store: this.$store,
        route: to
      }).then(next).catch(next);
    } else {
      next();
    }
  }
});

router.onReady(function () {
  // 添加路由钩子函数，用于处理 asyncData.
  // 在初始路由 resolve 后执行，
  // 以便我们不会二次预取(double-fetch)已有的数据。
  // 使用 `router.beforeResolve()`，以便确保所有异步组件都 resolve。
  router.afterEach(function (to, from, next) {
    window.scrollTo(0, 0);
  });
  router.beforeResolve(function (to, from, next) {
    var matched = router.getMatchedComponents(to);
    var prevMatched = router.getMatchedComponents(from);

    // 我们只关心非预渲染的组件
    // 所以我们对比它们，找出两个匹配列表的差异组件
    var diffed = false;
    var activated = matched.filter(function (c, i) {
      return diffed || (diffed = prevMatched[i] !== c);
    });

    if (!activated.length) {
      return next();
    }

    // 这里如果有加载指示器 (loading indicator)，就触发

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(activated.map(function (c) {
      if (c.asyncData) {
        return c.asyncData({ store: store, route: to });
      }
    })).then(function () {
      next();
    }).catch(next);
  });

  app.$mount('#app');
});

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["a"] = CreateApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filters___ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_config__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__semantic_dist_semantic_min_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flatpickr_dist_flatpickr_css__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_styles_sprite_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_styles_sprite_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_styles_sprite_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_styles_site_less__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_styles_site_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_styles_site_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_google_signin_button__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_google_signin_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_google_signin_button__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








/* semantic ui */


/* swiper */





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_google_signin_button___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.RouterConfig = __WEBPACK_IMPORTED_MODULE_4__router_config__["a" /* default */];

if (process.browser) {
  var VueAwesomeSwiper = __webpack_require__(214);
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueAwesomeSwiper);
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('dateToString', function (dateStr, fmt) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__components_filters___["a" /* dateToString */])(dateStr, fmt);
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('price', function (priceStr) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__components_filters___["b" /* price */])(priceStr);
});

function CreateApp() {
  var router = new __WEBPACK_IMPORTED_MODULE_3__router__["a" /* CreateRouter */]();
  var store = new __WEBPACK_IMPORTED_MODULE_6__store__["a" /* CreateStore */]();

  Object(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__["sync"])(store, router);

  var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    // el: '#app',
    router: router,
    api: __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */],
    store: store,
    template: '<App/>',
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
    }
  });
  return { app: app, router: router, store: store };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e29fbb1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(134);
function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e29fbb1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollToTop_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27525c50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollToTop_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27525c50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27525c50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-fade-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.toTopShow),expression:"toTopShow"}],staticClass:"page-component-up",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"icon-btn-backtotop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */,
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-global-login",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',[_c('div',{staticClass:"fc-login-form"},[_c('h5',[_vm._v("Welcome, kindly login to proceed")]),_vm._v(" "),_c('form',[_c('div',[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('a',{on:{"click":_vm.forgotpassword}},[_vm._v("Forgot password?")])]),_vm._v(" "),_c('a',{on:{"click":_vm.login}},[_vm._v("LOGIN")])]),_vm._v(" "),_c('div',{staticClass:"fc-register"},[_c('h5',[_vm._v("I'm new")]),_vm._v(" "),_c('a',{on:{"click":_vm.register}},[_vm._v("REGISTER")])]),_vm._v(" "),_c('div',{staticClass:"fc-login-third"},[_c('facebook-login',{staticClass:"button",attrs:{"appId":"445932519566099","loginLabel":"Continue with Facebook"},on:{"login":_vm.loginWithFB,"sdk-loaded":_vm.fbLoaded}},[_c('a',{staticClass:"fc-login-facebook"},[_vm._v("Continue with Facebook")])]),_vm._v(" "),_c('g-signin-button',{attrs:{"params":_vm.googleSignInParams},on:{"success":_vm.onSignInSuccess,"error":_vm.onSignInError}},[_c('a',{staticClass:"fc-login-google"},[_vm._v("Continue with Google")])])],1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"fc-global-login_close",on:{"click":_vm.close}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("EMAIL ADDRESS")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("PASSWORD")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"icon-img-subway-login fc-mobile-hide"}),_vm._v(" "),_c('i',{staticClass:"icon-img-subway-login2 fc-mobile-show"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bbe4c91_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(126);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bbe4c91_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideCartList),expression:"hideCartList"}],staticClass:"fc-cart"},[_c('a',{on:{"click":function($event){_vm.showCart = !_vm.showCart}}},[_vm._v(_vm._s(_vm.cartsProducts.length)),_c('span',{staticClass:"fc-mobile-hide"},[_vm._v("($"+_vm._s(_vm._f("price")(_vm.items.SubTotal))+")")])]),_vm._v(" "),(_vm.showCart && _vm.items.CartsProducts.length > 0)?_c('div',{staticClass:"fc-cart-products-list"},[(_vm.items.DeliveryType == 1)?_c('div',{staticClass:"fc-deliver-price"},[(_vm.items.SubTotal < _vm.items.MinimumPurchaseForDelivery)?_c('span',[_vm._v("$"+_vm._s(_vm._f("price")((_vm.items.MinimumPurchaseForDelivery - _vm.items.SubTotal)))+" more for delivery")]):(_vm.items.SubTotal < _vm.items.FreeDeliveryPurchaseAmount)?_c('span',[_vm._v("$"+_vm._s(_vm._f("price")((_vm.items.FreeDeliveryPurchaseAmount - _vm.items.SubTotal)))+" more for "),_c('b',[_vm._v("FREE")]),_vm._v(" delivery")]):_c('span',[_vm._v("You got yourself "),_c('b',[_vm._v("FREE")]),_vm._v(" delivery!")]),_vm._v(" "),_c('div',{staticClass:"fc-proress"},[_c('div',{class:{'fc-full': _vm.items.FreeDeliveryPurchaseAmount < _vm.items.SubTotal},style:({'width': _vm.statusPercent})})])]):_vm._e(),_vm._v(" "),(_vm.items.DeliveryType == 0)?_c('div',{staticClass:"fc-self-pickup"},[_c('label',[_vm._v("PICKUP OUTLET:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.items.OutletName))])]):_vm._e(),_vm._v(" "),(_vm.items.DeliveryType == -1)?_c('div',{staticClass:"fc-deliver-address"},[_c('label',[_vm._v("DELIVERY ADDRESS:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.items.DeliveryAddress))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fc-cart-products"},[_c('ul',_vm._l((_vm.cartsProducts),function(product){return _c('li',[_c('div',[_c('span',[_vm._v(_vm._s(product.Qty)+"x")]),_vm._v(" "),(product.BoxName != null && product.BoxName != '')?_c('span',[_vm._v(_vm._s(product.ProductName)+" - "+_vm._s(product.BoxName))]):_c('span',[_vm._v(_vm._s(product.ProductName))]),_vm._v(" "),_c('span',[_vm._v("$ "+_vm._s(_vm._f("price")(product.SubTotal)))]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.remove(product)}}})])])}),0)]),_vm._v(" "),_c('div',{staticClass:"fc-cart-checkout"},[_c('div',[_vm._v("\n\t\t\t\t\tSUBTOTAL: $"+_vm._s(_vm._f("price")(_vm.items.SubTotal))+"\n\t\t\t\t")]),_vm._v(" "),_c('div',[_c('a',{class:{ 'fc-active': _vm.enableCheckout },attrs:{"disabled":!_vm.enableCheckout},on:{"click":_vm.toCartDetail}},[_vm._v("GO TO CART")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickupOrDelivery_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383d4d4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickupOrDelivery_vue__ = __webpack_require__(130);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickupOrDelivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383d4d4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickupOrDelivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFirstItem)?_c('div',{staticClass:"fc-pickup-or-delivery"},[_c('div',{staticClass:"fc-pop-container"},[_c('div',{staticClass:"fc-title"},[_vm._v("Select one of the following")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"fc-content"},[_c('div',{class:{ 'fc-pickup': true, 'fc-active': _vm.tabIndex == 1 },on:{"click":function($event){_vm.tabIndex = 1}}},[_c('i',{staticClass:"icon-ico-pickup"}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{class:{ 'fc-delivery': true, 'fc-active': _vm.tabIndex == 2 },on:{"click":function($event){_vm.tabIndex = 2}}},[_c('i',{staticClass:"icon-ico-delivery"}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),(_vm.tabIndex == 1)?_c('div',{staticClass:"fc-content_section fc-content-pickup"},[_c('div',{staticClass:"fc-pickup-list"},[_c('span',[_vm._v("PICKUP OUTLET")]),_vm._v(" "),_c('ul',_vm._l((_vm.preAdd.Outlets),function(outlet){return _c('li',{class:{ 'fc-active': _vm.selectedOutletId == outlet.OutletId },on:{"click":function($event){_vm.selectedOutletId = outlet.OutletId}}},[_c('div',{domProps:{"innerHTML":_vm._s(outlet.Address)}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(outlet.OperatingHours)}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"fc-pickup-date"},[_c('div',[_c('span',[_vm._v("PICKUP DATE")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"DD/MM/YYYY","config":{minDate: new Date(), dateFormat: 'Y-m-d', disableMobile: true}},model:{value:(_vm.pickupDateDate),callback:function ($$v) {_vm.pickupDateDate=$$v},expression:"pickupDateDate"}})],1),_vm._v(" "),_c('div',[_c('span',[_vm._v("PICKUP TIME")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"HH:MM","config":{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true},"step":"60"},on:{"on-open":_vm.dayCreate},model:{value:(_vm.pickupDateTime),callback:function ($$v) {_vm.pickupDateTime=$$v},expression:"pickupDateTime"}})],1),_vm._v(" "),(_vm.tabIndex > 0)?_c('div',{staticClass:"fc-control"},[_c('a',{attrs:{"disabled":!_vm.pickupEnable},on:{"click":_vm.selectDeliver}},[_vm._v("CONTINUE")])]):_vm._e()]),_vm._v(" "),(_vm.hasPickupError)?_c('div',{staticClass:"fc-error"},[_vm._v("Sorry, we are unable to handle orders at the selected time. Please choose another timing.")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.tabIndex == 2)?_c('div',{staticClass:"fc-content_section fc-content-deliver"},[_c('div',{staticClass:"fc-deliver-address"},[_c('span',[_vm._v("DELIVER TO:")]),_vm._v(" "),_c('div',[_c('label',[_vm._v("POSTAL CODE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliverAddress.postalCode),expression:"deliverAddress.postalCode"}],attrs:{"type":"text","minlength":"6","maxlength":"6"},domProps:{"value":(_vm.deliverAddress.postalCode)},on:{"blur":_vm.selectOutlet,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deliverAddress, "postalCode", $event.target.value)}}}),_vm._v(" "),_c('a',[_vm._v("Singapore ONLY")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('label',[_vm._v("UNIT NO.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliverAddress.unitNo),expression:"deliverAddress.unitNo"}],attrs:{"type":"text"},domProps:{"value":(_vm.deliverAddress.unitNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deliverAddress, "unitNo", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("#")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('label',[_vm._v("ADDRESS")]),_vm._v(" "),_c('input',{attrs:{"readonly":"readonly","type":"text"},domProps:{"value":_vm.address.ADDRESS}})])]),_vm._v(" "),_c('div',{staticClass:"fc-pickup-date"},[_c('div',[_c('span',[_vm._v("DELIVER DATE")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"DD/MM/YYYY","config":{minDate: new Date(), dateFormat: 'Y-m-d', disableMobile: true}},model:{value:(_vm.pickupDateDate),callback:function ($$v) {_vm.pickupDateDate=$$v},expression:"pickupDateDate"}})],1),_vm._v(" "),_c('div',[_c('span',[_vm._v("DELIVER TIME")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"HH:MM","config":{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true},"step":"60"},on:{"on-open":_vm.dayCreate},model:{value:(_vm.pickupDateTime),callback:function ($$v) {_vm.pickupDateTime=$$v},expression:"pickupDateTime"}})],1),_vm._v(" "),(_vm.tabIndex > 0)?_c('div',{staticClass:"fc-control"},[_c('a',{attrs:{"disabled":!_vm.deliveryEnable},on:{"click":_vm.selectDeliver}},[_vm._v("CONTINUE")])]):_vm._e()]),_vm._v(" "),(_vm.hasError)?_c('div',{staticClass:"fc-error"},[_vm._v("Sorry, we are unable to handle orders at the selected time. Please choose another timing.")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fc-close",on:{"click":_vm.close}})])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-note"},[_vm._v("Please note, order need to be made 2 hours in advanced. "),_c('br'),_vm._v("\nCall our store directly for order <2 hours. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v("STORE PICKUP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v("DELIVERY")]),_vm._v(" "),_c('p',[_vm._v("\n              Minimum order $50"),_c('br'),_vm._v("\n              Order above $180 will get FREE delivery"),_c('br'),_vm._v("\n              Delivery timing 9.30am to 10pm daily\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a9893c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(133);
function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var normalizeComponent = __webpack_require__(17)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54a9893c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a9893c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-loading"},[_c('div',[_c('div',{staticClass:"fc-loading-loader"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeUserControl),expression:"closeUserControl"}]},[_c('div',{staticClass:"fc-login"},[_c('div',{staticClass:"ui container"},[_c('div',[_vm._v("Get 5% cash rebate for your next order!")]),_vm._v(" "),_c('div',{staticClass:"fc-mobile-hide"},[_c('div',[_c('router-link',{attrs:{"to":("" + (this.RouterConfig.OurLocation))}},[_vm._v("Our Location")])],1),_vm._v(" "),_c('div',{staticClass:"fc-user-info"},[(_vm.loginInfo == null)?_c('a',{on:{"click":function($event){_vm.showlogin = !_vm.showlogin}}},[_vm._v("Login / Register")]):_vm._e(),_vm._v(" "),(_vm.loginInfo != null)?_c('a',{on:{"click":function($event){_vm.showUserControl = !_vm.showUserControl}}},[_vm._v(_vm._s(_vm.loginInfo.FullName))]):_vm._e(),_vm._v(" "),(_vm.showUserControl)?_c('ul',{staticClass:"fc-user-control"},[_c('li',{staticClass:"fc-order"},[_c('a',{on:{"click":_vm.myOrders}},[_vm._v("My Orders")])]),_vm._v(" "),_c('li',{staticClass:"fc-credit"},[_c('a',{on:{"click":_vm.myCredit}},[_vm._v("My Credit")])]),_vm._v(" "),_c('li',{staticClass:"fc-address"},[_c('a',{on:{"click":_vm.myInformation}},[_vm._v("My Information")])]),_vm._v(" "),_c('li',{staticClass:"fc-logout"},[_c('a',{on:{"click":_vm.logout}},[_vm._v("Logout")])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"ui container fc-navigator"},[_c('div',[_c('a',{class:{ 'fc-mobile-show': true, 'fc-mobile-menu': true, 'fc-active': _vm.isMobileMenuActive },on:{"click":function($event){_vm.isMobileMenuActive = !_vm.isMobileMenuActive}}}),_vm._v(" "),_c('a',{staticClass:"fc-mobile-hide icon-logo",attrs:{"href":"/"}}),_vm._v(" "),_c('div',{class:{ 'fc-mobile-nav': true, 'fc-active': _vm.isMobileMenuActive },on:{"touchmove":function($event){$event.preventDefault();},"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.isMobileMenuActive = false}}},[(_vm.categoryList != null && _vm.categoryList != undefined)?_c('ul',_vm._l((_vm.categoryList),function(item){return _c('li',[_c('a',{attrs:{"href":item.UrlAliase}},[_vm._v(_vm._s(item.Name))])])}),0):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"fc-mobile-show"},[_c('li',[_c('a',{on:{"click":_vm.ourLocation}},[_vm._v("Our Location")])]),_vm._v(" "),_c('li',[(_vm.loginInfo == null)?_c('a',{on:{"click":function($event){_vm.showlogin = !_vm.showlogin}}},[_vm._v("Login / Register")]):_vm._e(),_vm._v(" "),(_vm.loginInfo != null)?_c('a',{staticClass:"fc-user-info",on:{"click":function($event){_vm.showUserControl = !_vm.showUserControl}}},[_vm._v(_vm._s(_vm.loginInfo.FullName))]):_vm._e(),_vm._v(" "),(_vm.showUserControl)?_c('ul',{staticClass:"fc-user-control"},[_c('li',{staticClass:"fc-order"},[_c('a',{on:{"click":_vm.myOrders}},[_vm._v("My Orders")])]),_vm._v(" "),_c('li',{staticClass:"fc-credit"},[_c('a',{on:{"click":_vm.myCredit}},[_vm._v("My Credit")])]),_vm._v(" "),_c('li',{staticClass:"fc-address"},[_c('a',{on:{"click":_vm.myInformation}},[_vm._v("My Information")])]),_vm._v(" "),_c('li',{staticClass:"fc-logout"},[_c('a',{on:{"click":_vm.logout}},[_vm._v("Logout")])])]):_vm._e()])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('fc-cart')],1)]),_vm._v(" "),_c('main',[_c('router-view')],1),_vm._v(" "),_c('footer',[_c('div',{staticClass:"ui container"},[_c('div',{staticClass:"fc-help"},[_c('div',[_c('span',[_vm._v("MENU")]),_vm._v(" "),(_vm.categoryList != null && _vm.categoryList != undefined)?_c('ul',_vm._l((_vm.categoryList),function(item){return _c('li',[_c('a',{attrs:{"href":item.UrlAliase}},[_vm._v(_vm._s(item.Name))])])}),0):_vm._e()]),_vm._v(" "),_c('div',[_c('span',[_vm._v("SUPPORT")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":("" + (this.RouterConfig.OurLocation))}},[_vm._v("Our Locations")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":("" + (this.RouterConfig.ContactUs))}},[_vm._v("Contact Us")])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":("" + (this.RouterConfig.FAQ))}},[_vm._v("FAQ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":("" + (this.RouterConfig.UserTerm))}},[_vm._v("Terms & Conditions")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":("" + (this.RouterConfig.PrivacyPolicy))}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('scroll-top'),_vm._v(" "),(_vm.showlogin)?_c('fc-login',{on:{"closelogin":function($event){_vm.showlogin = false}}}):_vm._e(),_vm._v(" "),_c('pickup-or-delivery'),_vm._v(" "),_c('loading',{staticStyle:{"display":"none"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-mobile-show"},[_c('a',{staticClass:"icon-logo2",attrs:{"href":"/"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticStyle:{"display":"none"}},[_c('a',{attrs:{"href":"/"}},[_vm._v("Career")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-copyright"},[_c('div',[_c('i',{staticClass:"icon-halal-logo"}),_vm._v(" "),_c('i',{staticClass:"icon-logo-visa"}),_vm._v(" "),_c('i',{staticClass:"icon-logo-mastercard"}),_vm._v(" "),_c('i',{staticClass:"icon-logo-amex"}),_vm._v(" "),_c('i',{staticClass:"icon-logo-stripe"})]),_vm._v(" "),_c('div',[_c('b',[_vm._v("SUBWAY® is a Registered Trademark of Subway IP Inc. ©2017 Subway IP Inc")]),_vm._v(" "),_c('p',[_vm._v("Copyright © 2019 Daily Bake 2 Pte Ltd . All Rights Reserved.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dateToString;
/* harmony export (immutable) */ __webpack_exports__["b"] = price;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);

function dateToString(dateStr, fmt) {
  if (dateStr === null || dateStr === undefined || dateStr === '') {
    return dateStr;
  }
  var date = new Date(Date.parse(dateStr.split('.')[0].replace(/-/g, '/').replace(/T/g, ' ')));
  if (fmt === null) {
    fmt = 'yyyy-m-dd';
  }
  // const monthArr = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SPT', 'OCT', 'NOV', 'DEC']
  var monthArr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': monthArr[date.getMonth()],
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function price(priceStr) {
  if (priceStr === null || priceStr === undefined || priceStr === '') {
    return priceStr;
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(priceStr).toFixed(2);
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(71);



// import Dashboard from '@/views/Dashboard'
// import ComboPackage from '@/views/ComboPackage'
// import Sandwiches from '@/views/Sandwiches'
// import Lunchboxes from '@/views/Lunchboxes'
// import Drinks from '@/views/Drinks'
// import Cookies from '@/views/Cookies'
// import ProductList from '@/views/product/ProductList'

// import CartDetail from '@/views/checkout/CartDetail'
// import Checkout from '@/views/checkout/Checkout'
// import Register from '@/views/profile/Register'
// import ForgotPassword from '@/views/profile/ForgotPassword'
// import GiantSub from '@/views/GiantSub'
// import CheckoutSuccess from '@/views/checkout/CheckoutSuccess'
// import OurLocation from '@/views/company/OurLocation'
// import ContactUs from '@/views/company/ContactUs'
// import FAQ from '@/views/company/FAQ'
// import UserTerm from '@/views/company/UserTerm'
// import PrivacyPolicy from '@/views/company/PrivacyPolicy'
// profile
// import MyOrders from '@/views/profile/Orders'
// import MyOrderDetail from '@/views/profile/OrderDetail'
// import MyCredit from '@/views/profile/Credit'
// import MyInformation from '@/views/profile/Information'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function CreateRouter() {
  return new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
      path: '/',
      name: 'dashboard',
      component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 82));
      }
    }, {
      path: '',
      name: 'emptydashboard',
      component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 82));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].CartDetail,
      name: 'cartdetail',
      component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 218));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].Checkout,
      name: 'checkout',
      component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 219));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].Register,
      name: 'register',
      component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 220));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].ForgotPassword,
      name: 'forgotpassword',
      component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 221));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].CheckoutSuccess,
      name: 'CheckoutSuccess',
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 222));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].OurLocation,
      name: 'OurLocation',
      component: function component() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 223));
      }
    },
    // profile
    {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MyOrders,
      name: 'MyOrders',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 224));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MyOrderDetail,
      name: 'MyOrderDetail',
      component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 225));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MyCredit,
      name: 'MyCredit',
      component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 226));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MyInformation,
      name: 'MyInformation',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 227));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].ContactUs,
      name: 'ContactUs',
      component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 228));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FAQ,
      name: 'FAQ',
      component: function component() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 229));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].UserTerm,
      name: 'UserTerm',
      component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 230));
      }
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].PrivacyPolicy,
      name: 'PrivacyPolicy',
      component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 231));
      }
    }, {
      path: '*',
      name: 'ProductList',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 232));
      }
    }]
  });
}

/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__url_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery_confirm_dist_jquery_confirm_min_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery_confirm_dist_jquery_confirm_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery_confirm_dist_jquery_confirm_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery_confirm_dist_jquery_confirm_min_css__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery_confirm_dist_jquery_confirm_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery_confirm_dist_jquery_confirm_min_css__);









var numberOfPending = 0;
var errorAlert = false;

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_5__url_js__["a" /* default */].baseUrl;
// axios.defaults.baseURL = '/api'

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  numberOfPending++;
  if (process.browser) {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.fc-loading').show();
  }
  if (config.url.indexOf(__WEBPACK_IMPORTED_MODULE_5__url_js__["a" /* default */].address) > -1) {
    return config;
  }
  var token = 'token';

  if (process.browser) {
    var loginInfo = sessionStorage.getItem('loginInfo');
    if (loginInfo !== null && loginInfo !== undefined && loginInfo !== 'undefined' && loginInfo !== 'null') {
      var info = JSON.parse(sessionStorage.getItem('loginInfo'));
      token = info.Token;
    }
  }
  config.headers['Content-Type'] = 'application/json;charset=utf-8';

  var exdata = config.data;
  if ((typeof exdata === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(exdata)) === 'object' && Object.prototype.toString.call(exdata).toLowerCase() === '[object object]' && !exdata.length) {} else if (exdata !== undefined && exdata !== '') {
    exdata = JSON.parse(exdata);
  }
  var randomNumber = '';
  if (process.browser) {
    randomNumber = localStorage.getItem('tokenId');
    if (randomNumber === null || randomNumber === undefined) {
      randomNumber = '';
    }
  } else {
    randomNumber = '';
  }
  if (randomNumber === '' && process.browser) {
    randomNumber = 'xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/x/g, function (c) {
      var r = Math.random() * 16 | 0;
      return r.toString(16);
    });
    localStorage.setItem('tokenId', randomNumber);
  }
  config.data = {
    CompanyId: 5,
    Token: token,
    Data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      BrowserRandomNumber: randomNumber
    }, exdata)
  };

  return config;
});
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  numberOfPending--;
  errorAlert = false;
  if (numberOfPending <= 0) {
    if (process.browser) {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.fc-loading').hide();
    }
  }
  if (response.data.Status === 'Success') {
    return response.data.Data;
  } else {
    if (process.browser) {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert({
        title: 'Fail',
        content: response.data.Message,
        type: 'red',
        useBootstrap: false
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data.Message);
  }
}, function (error) {
  numberOfPending--;
  if (numberOfPending <= 0) {
    if (process.browser) {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.fc-loading').hide();
    }
  }
  if (errorAlert) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  if (error.message === 'cancel') {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  errorAlert = true;
  if (error.response) {
    switch (error.response.status) {
      case 401:
        if (process.browser) {
          sessionStorage.removeItem('loginInfo');
          window.location.href = '/';
        }
        break;
      case 400:
        if (error.response.data != null && error.response.data.error_description != null) {
          if (process.browser) {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert({
              title: 'Fail',
              content: error.response.data.error_description,
              type: 'red',
              useBootstrap: false
            });
          }
        }
        break;
      default:
        if (process.browser) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert({
            title: 'Fail',
            content: 'Network Error',
            type: 'red',
            useBootstrap: false
          });
        }
        break;
    }
  } else {
    if (process.browser) {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert({
        title: 'Fail',
        content: 'Network Error',
        type: 'red',
        useBootstrap: false
      });
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
/* harmony default export */ __webpack_exports__["a"] = ({});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(175);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(21)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../vue-style-loader/index.js!../../css-loader/index.js??ref--8-2!./jquery-confirm.min.css", function() {
		var newContent = require("!!../../extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../vue-style-loader/index.js!../../css-loader/index.js??ref--8-2!./jquery-confirm.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */,
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_home_home_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_company_faq_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_company_contactus_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_home_address_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_category_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_company_outlet_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_product_product__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_profile_login__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_profile_customer__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_cart__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_order___ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_customize__ = __webpack_require__(200);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

function CreateStore() {
  return new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
      home: __WEBPACK_IMPORTED_MODULE_2__modules_home_home_js__["a" /* default */],
      faq: __WEBPACK_IMPORTED_MODULE_3__modules_company_faq_js__["a" /* default */],
      contact: __WEBPACK_IMPORTED_MODULE_4__modules_company_contactus_js__["a" /* default */],
      address: __WEBPACK_IMPORTED_MODULE_5__modules_home_address_js__["a" /* default */],
      category: __WEBPACK_IMPORTED_MODULE_6__modules_category_js__["a" /* default */],
      outlet: __WEBPACK_IMPORTED_MODULE_7__modules_company_outlet_js__["a" /* default */],
      product: __WEBPACK_IMPORTED_MODULE_8__modules_product_product__["a" /* default */],
      profileLogin: __WEBPACK_IMPORTED_MODULE_9__modules_profile_login__["a" /* default */],
      customer: __WEBPACK_IMPORTED_MODULE_10__modules_profile_customer__["a" /* default */],
      cart: __WEBPACK_IMPORTED_MODULE_11__modules_cart__["a" /* default */],
      order: __WEBPACK_IMPORTED_MODULE_12__modules_order___["a" /* default */],
      custmoize: __WEBPACK_IMPORTED_MODULE_13__modules_customize__["a" /* default */]
    },
    strict: debug
  });
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_home_home__ = __webpack_require__(179);




// initial state
var state = {
  home: []

  // getters
};var getters = {
  home: function home(state, getters) {
    var staticState = state.home;
    if (staticState != null) {
      return staticState;
    }
    if (process.browser) {
      return JSON.parse(localStorage.getItem('home'));
    }
  }

  // actions
};var actions = {
  getHome: function getHome(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_home_home__["a" /* default */].getHome().then(function (res) {
        commit('setHome', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var mutations = {
  setHome: function setHome(state, res) {
    if (process.browser) {
      localStorage.setItem('home', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
    }
    state.home = res;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function _getHome() {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].home);
}

function fetch(urlString) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: urlString,
      dataType: 'json'
    }).then(function (response) {
      resolve(response);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getHome: function getHome() {
    return _getHome();
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_company_faq__ = __webpack_require__(181);




// initial state
var state = {
  faqList: []

  // getters
};var getters = {
  faqList: function faqList(state, getters) {
    var staticState = state.faqList;
    if (staticState != null && staticState.length > 0) {
      return staticState;
    }
    if (process.browser) {
      return JSON.parse(localStorage.getItem('faqList'));
    } else {
      return [];
    }
  }

  // actions
};var actions = {
  getFAQ: function getFAQ(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_company_faq__["a" /* default */].getFAQ().then(function (res) {
        commit('setList', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var mutations = {
  setList: function setList(state, res) {
    if (process.browser) {
      localStorage.setItem('faqList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
    }
    state.faqList = res;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function fetch() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: __WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].faq,
      dataType: 'json'
    }).then(function (response) {
      resolve(response.Faqs);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getFAQ: function getFAQ() {
    return fetch();
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_company_contactus__ = __webpack_require__(183);



// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {
  contactUs: function contactUs(_ref, data) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_company_contactus__["a" /* default */].contactUs(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function fetch(data) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: __WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].contactUs,
      data: data,
      dataType: 'json'
    }).then(function (response) {
      resolve(response);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  contactUs: function contactUs(data) {
    return fetch(data);
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_home_address__ = __webpack_require__(185);



// initial state
var state = {
  address: {}

  // getters
};var getters = {
  address: function address(state, getters) {
    if (state.address.BUILDING === null || state.address.BUILDING === undefined) {
      return { ADDRESS: '' };
    }
    var add = {
      ADDRESS: state.address.BLK_NO + ' ' + state.address.ROAD_NAME + ' ' + state.address.BUILDING
    };
    return add;
  }

  // actions
};var actions = {
  getAddress: function getAddress(_ref, postalCode) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (postalCode.length !== 6) {
        resolve(null);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__api_home_address__["a" /* default */].getAddress(postalCode).then(function (res) {
          if (res.found >= 1 && res.results.length > 0) {
            resolve(res.results[0]);
            commit('setAddress', res.results[0]);
          } else {
            commit('setAddress', {});
            resolve(null);
          }
        }).catch(function (error) {
          reject(error);
        });
      }
    });
  }
};

// mutations
var mutations = {
  setAddress: function setAddress(state, res) {
    state.address = res;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url__ = __webpack_require__(6);

// import axios from 'axios'



function fetch(postalCode) {
  if (process.browser) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
        url: __WEBPACK_IMPORTED_MODULE_2__url__["a" /* default */].address,
        type: 'get',
        dataType: 'json',
        data: {
          searchVal: postalCode,
          returnGeom: 'N',
          getAddrDetails: 'Y',
          pageNum: '1'
        }
      }).done(function (result) {
        resolve(result);
      });
    });
  }

  // return new Promise((resolve, reject) => {
  //   axios({
  //     method: 'GET',
  //     url: url.address,
  //     data: {
  //       searchVal: postalCode,
  //       returnGeom: 'N',
  //       getAddrDetails: 'Y',
  //       pageNum: '1'
  //     },
  //     dataType: 'json'
  //   })
  //     .then(response => {
  //       resolve(response)
  //     })
  // })
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getAddress: function getAddress(postalCode) {
    return fetch(postalCode);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_category__ = __webpack_require__(187);




// initial state
var state = {
  categoryList: []

  // getters
};var getters = {
  categoryList: function categoryList(state, getters) {
    var staticState = state.categoryList;
    if (staticState != null && staticState.length > 0) {
      return staticState;
    }
    if (process.browser) {
      return JSON.parse(localStorage.getItem('categoryList'));
    } else {
      return [];
    }
  }

  // actions
};var actions = {
  getCategory: function getCategory(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_category__["a" /* default */].getCategory().then(function (res) {
        commit('setCategoryList', res);
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var mutations = {
  setCategoryList: function setCategoryList(state, res) {
    if (process.browser) {
      localStorage.setItem('categoryList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
    }
    state.categoryList = res;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function fetch() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: __WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].category,
      dataType: 'json'
    }).then(function (response) {
      resolve(response.Categories);
    }).catch(function () {});
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getCategory: function getCategory() {
    return fetch();
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_company_outlet__ = __webpack_require__(189);




// initial state
var state = {
  outletList: []

  // getters
};var getters = {
  outletList: function outletList(state, getters) {
    var staticState = state.outletList;
    if (staticState != null && staticState.length > 0) {
      return staticState;
    }
    if (process.browser) {
      return JSON.parse(localStorage.getItem('outletList'));
    }
  }

  // actions
};var actions = {
  getOutlet: function getOutlet(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_company_outlet__["a" /* default */].getOutlet().then(function (res) {
        commit('setOutletList', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var mutations = {
  setOutletList: function setOutletList(state, res) {
    if (process.browser) {
      localStorage.setItem('outletList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
    }
    state.outletList = res;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function fetch() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: __WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].outlet,
      dataType: 'json'
    }).then(function (response) {
      resolve(response.Outlets);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getOutlet: function getOutlet() {
    return fetch();
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_product_product__ = __webpack_require__(191);





// initial state
var state = {
  products: {
    AllIncludeOptions: [],
    OtherProducts: [],
    Products: []
  },
  productDetail: {
    BasePrice: 0,
    CategoryId: 0,
    CategoryName: '',
    ProductId: 0,
    ProductName: '',
    ProductsMainOptionId: 0,
    ProductsMainOptionName: '',
    ProductsOptions: [],
    quantity: 1,
    OptionsVariantIds: []
  }

  // getters
};var getters = {
  getField: __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["a" /* getField */],
  finish: function finish(state, getters) {
    var selOptionIds = state.productDetail.OptionsVariantIds;
    var needOptions = state.productDetail.ProductsOptions.filter(function (a) {
      return !a.AllowNo && a.DisplayNoOption;
    });
    if (needOptions === null || needOptions === undefined || needOptions.length < 1) {
      return true;
    }
    var selCount = 0;
    for (var i = 0; i < needOptions.length; i++) {
      var vars = needOptions[i].Variants;
      for (var j = 0; j < vars.length; j++) {
        if (selOptionIds.indexOf(vars[j].OptionsVariantId) > -1) {
          selCount++;
          break;
        }
      }
    }
    return selCount >= needOptions.length;
  }

  // actions
};var actions = {
  getProductList: function getProductList(_ref, data) {
    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;

    if (data === null || data === undefined) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(''));
    }
    var catId = 0;
    var categoryList = rootGetters['category/categoryList'];
    if (categoryList === null || categoryList === undefined || categoryList.length < 1) {
      this.dispatch('category/getCategory').then(function (catlist) {
        var tmpCategory = catlist.filter(function (a) {
          return a.UrlAliase === data.path;
        });
        if (tmpCategory !== null && tmpCategory.length > 0) {
          catId = tmpCategory[0].CategoryId;
        }
        var catData = {
          CategoryId: parseInt(catId)
        };
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_2__api_product_product__["a" /* default */].getProduct(catData).then(function (res) {
            commit('setProducts', res);
            resolve(res);
          }).catch(function (error) {
            reject(error);
          });
        });
      });
    } else {
      var tmpCategory = categoryList.filter(function (a) {
        return a.UrlAliase === data.path;
      });
      if (tmpCategory !== null && tmpCategory.length > 0) {
        catId = tmpCategory[0].CategoryId;
      }
      var catData = {
        CategoryId: parseInt(catId)
      };
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api_product_product__["a" /* default */].getProduct(catData).then(function (res) {
          commit('setProducts', res);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },
  getProductDetails: function getProductDetails(_ref2, data) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_product_product__["a" /* default */].getProductDetail(data.productId, data.optionId).then(function (res) {
        commit('setProductDetail', res);
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  changeQuantity: function changeQuantity(_ref3, qty) {
    var state = _ref3.state,
        commit = _ref3.commit;

    commit('changeQuantity', qty);
  },
  selectOption: function selectOption(_ref4, id) {
    var state = _ref4.state,
        commit = _ref4.commit;

    commit('selectOption', id);
  },
  resetOption: function resetOption(_ref5, option) {
    var state = _ref5.state,
        commit = _ref5.commit;

    commit('resetOption', option);
  }
};

// mutations
var mutations = {
  updateField: __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["d" /* updateField */],
  setProducts: function setProducts(state, res) {
    var tmpProducts = res.Products.map(function (item) {
      item.quantity = 1;
      return item;
    });
    res.Products = tmpProducts;
    state.products = res;
  },
  setProductDetail: function setProductDetail(state, res) {
    res.quantity = 1;
    var ids = [];
    for (var i = 0; i < res.ProductsOptions.length; i++) {
      for (var j = 0; j < res.ProductsOptions[i].Variants.length; j++) {
        if (res.ProductsOptions[i].Variants[j].Standard) {
          ids.push(res.ProductsOptions[i].Variants[j].OptionsVariantId);
        }
      }
      if (res.ProductsOptions[i].AllowNo && res.ProductsOptions[i].DisplayNoOption) {
        res.ProductsOptions[i].Variants.push({
          OptionsVariantId: 0 - res.ProductsOptions[i].ProductsOptionId,
          OptionsVariantName: 'No ' + res.ProductsOptions[i].ProductsOptionName,
          OptionsVariantPrice: 0,
          PhotoKey: '',
          Standard: false
        });
      }
    }
    res.OptionsVariantIds = ids;
    state.productDetail = res;
  },
  changeQuantity: function changeQuantity(state, qty) {
    state.productDetail.quantity = qty;
  },
  resetOption: function resetOption(state, option) {
    var ids = state.productDetail.OptionsVariantIds;
    if (option.Variants.length < 1) {
      return;
    }
    for (var i = 0; i < option.Variants.length; i++) {
      var index = ids.indexOf(option.Variants[i].OptionsVariantId);
      if (index >= 0) {
        ids.splice(index, 1);
      }
    }
    for (var j = 0; j < option.Variants.length; j++) {
      if (option.Variants[j].Standard === true) {
        ids.push(option.Variants[j].OptionsVariantId);
      }
    }
  },
  selectOption: function selectOption(state, id) {
    var ids = state.productDetail.OptionsVariantIds;
    var index = ids.indexOf(id);
    if (id < 0) {
      if (index < 0) {
        ids.push(id);
        var theID = 0 - id;
        var noneRow = state.productDetail.ProductsOptions.filter(function (a) {
          return a.ProductsOptionId === theID;
        });
        if (noneRow.length > 0) {
          var noneVariants = noneRow[0].Variants.filter(function (a) {
            return a.OptionsVariantId !== id;
          });
          for (var j = 0; j < noneVariants.length; j++) {
            var tmpIndex = ids.indexOf(noneVariants[j].OptionsVariantId);
            if (tmpIndex >= 0) {
              ids.splice(tmpIndex, 1);
            }
          }
        }
      } else {
        ids.splice(index, 1);
      }
    } else {
      if (index < 0) {
        for (var i = 0; i < state.productDetail.ProductsOptions.length; i++) {
          var existRow = state.productDetail.ProductsOptions[i].Variants.filter(function (a) {
            return a.OptionsVariantId === id;
          });
          if (existRow.length <= 0) {
            continue;
          }
          var exist = 0;
          var firstExistId = 0;
          for (var k = 0; k < state.productDetail.ProductsOptions[i].Variants.length; k++) {
            var tmpVarId = state.productDetail.ProductsOptions[i].Variants[k].OptionsVariantId;
            if (ids.indexOf(tmpVarId) >= 0) {
              if (tmpVarId < 0) {
                ids.splice(ids.indexOf(tmpVarId), 1);
              } else {
                firstExistId = tmpVarId;
                exist++;
              }
            }
          }
          if (exist >= state.productDetail.ProductsOptions[i].UpTo && state.productDetail.ProductsOptions[i].UpTo > 0) {
            ids.splice(ids.indexOf(firstExistId), 1);
          }
        }
        ids.push(id);
      } else {
        ids.splice(index, 1);
      }
    }
    state.productDetail.OptionsVariantIds = ids;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function fetch(data) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: __WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].product,
      data: data,
      dataType: 'json'
    }).then(function (response) {
      resolve(response);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function fetchDetail(id, optionId) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: __WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].productDetail,
      data: {
        ProductId: parseInt(id),
        ProductsMainOptionId: parseInt(optionId)
      },
      dataType: 'json'
    }).then(function (response) {
      resolve(response);
    }).catch(function () {});
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getProduct: function getProduct(data) {
    return fetch(data);
  },
  getProductDetail: function getProductDetail(id, optionId) {
    return fetchDetail(id, optionId);
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_profile_login__ = __webpack_require__(193);




// initial state
var state = {
  loginInfo: null

  // getters
};var getters = {
  loginInfo: function loginInfo(state, getters) {
    var staticState = state.loginInfo;
    if (staticState != null) {
      return staticState;
    }
    var info = null;
    if (process.browser) {
      info = sessionStorage.getItem('loginInfo');
      if (info === null || info === undefined || info === 'undefined' || info === 'null') {
        return null;
      }
    }
    return JSON.parse(info);
  }

  // actions
};var actions = {
  checkLogin: function checkLogin(_ref) {
    var commit = _ref.commit;

    commit('checkLogin');
  },
  login: function login(_ref2, data) {
    var commit = _ref2.commit;

    if (process.browser) {
      sessionStorage.removeItem('loginInfo');
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_login__["a" /* default */].login(data).then(function (res) {
        commit('setLoginInfo', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  signup: function signup(_ref3, data) {
    var commit = _ref3.commit;

    if (process.browser) {
      sessionStorage.removeItem('loginInfo');
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_login__["a" /* default */].signup(data).then(function (res) {
        commit('setLoginInfo', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  register: function register(_ref4, data) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_login__["a" /* default */].register(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  forgotpassword: function forgotpassword(_ref5, data) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_login__["a" /* default */].forgotpassword(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  forgotPasswordCheck: function forgotPasswordCheck(_ref6, data) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_login__["a" /* default */].forgotPasswordCheck(data).then(function (res) {
        commit('setLoginInfo', res);
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  resendEmail: function resendEmail(_ref7, data) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_login__["a" /* default */].resendEmail(data).then(function (res) {
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  validateCode: function validateCode(_ref8, data) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_login__["a" /* default */].validateCode(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  logout: function logout(_ref9) {
    var commit = _ref9.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_login__["a" /* default */].logout().then(function (res) {
        if (process.browser) {
          sessionStorage.removeItem('loginInfo');
        }
        commit('setLoginInfo', null);
        resolve();
      }).catch(function (error) {
        if (process.browser) {
          sessionStorage.removeItem('loginInfo');
        }
        reject(error);
      });
    });
  }
};

// mutations
var mutations = {
  setLoginInfo: function setLoginInfo(state, res) {
    if (res === null) {
      if (process.browser) {
        sessionStorage.removeItem('loginInfo');
      }
      state.loginInfo = null;
    } else {
      if (process.browser) {
        sessionStorage.setItem('loginInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
      }
      state.loginInfo = res;
    }
  },
  checkLogin: function checkLogin(state) {
    if (state.loginInfo === null) {
      if (process.browser) {
        var info = sessionStorage.getItem('loginInfo');
        if (info !== null && info !== undefined && info !== 'undefined' && info !== 'null') {
          state.loginInfo = JSON.parse(info);
        }
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function _login(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].login, data);
}
function _resendEmail(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].resendEmail, data);
}
function _validateCode(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].validateCode, data);
}
function _signup(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].signup, data);
}
function _register(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].register, data);
}
function _forgotpassword(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].forgotPassword, data);
}
function _forgotPasswordCheck(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].forgotPasswordCheck, data);
}
function _logout() {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].logout, null);
}
function fetch(urlString, data) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: urlString,
      data: data,
      dataType: 'json'
    }).then(function (response) {
      resolve(response);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(data) {
    return _login(data);
  },
  register: function register(data) {
    return _register(data);
  },
  forgotpassword: function forgotpassword(data) {
    return _forgotpassword(data);
  },
  forgotPasswordCheck: function forgotPasswordCheck(data) {
    return _forgotPasswordCheck(data);
  },
  logout: function logout() {
    return _logout();
  },
  signup: function signup(data) {
    return _signup(data);
  },
  resendEmail: function resendEmail(data) {
    return _resendEmail(data);
  },
  validateCode: function validateCode(data) {
    return _validateCode(data);
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__ = __webpack_require__(18);






// initial state
var state = {
  addressList: [],
  newAddress: {
    CustomersAddressId: 0,
    FullName: '',
    MobileNo: '',
    PostalCode: '',
    UnitNo: '',
    Address: '',
    BuildingName: '',
    IsDefault: false
  },
  selectedAddress: {},
  info: {}

  // getters
};var getters = {
  getField: __WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__["a" /* getField */],
  info: function info(state, getters) {
    return state.info;
  }

  // actions
};var actions = {
  getAddressList: function getAddressList(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].getAddressList().then(function (res) {
        commit('setAddressList', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  selectAddress: function selectAddress(_ref2, address) {
    var commit = _ref2.commit;

    commit('selectAddress', address);
  },
  addAddress: function addAddress(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if (state.newAddress.FullName === '') {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        resolve();
      });
    }
    var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.newAddress));
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].addAddress(data).then(function (res) {
        data.CustomersAddressId = res.CustomersAddressId;
        commit('addNewAddress', data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editAddress: function editAddress(_ref4, address) {
    var commit = _ref4.commit,
        state = _ref4.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].editAddress(address).then(function (res) {
        commit('editAddress', address);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  removeAddress: function removeAddress(_ref5, address) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var data = {
      CustomersAddressId: address.CustomersAddressId
    };
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].removeAddress(data).then(function (res) {
        commit('removeAddress', data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCustomerInfo: function getCustomerInfo(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].getCustomerInfo().then(function (res) {
        commit('setCustomerInfo', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editCustomerInfo: function editCustomerInfo(_ref7, data) {
    var commit = _ref7.commit,
        state = _ref7.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].editCustomerInfo(data).then(function (res) {
        commit('editCustomerInfo', data);
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editCustomerPassword: function editCustomerPassword(_ref8, data) {
    var commit = _ref8.commit,
        state = _ref8.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].editCustomerPassword(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  customerCredit: function customerCredit(_ref9, data) {
    var commit = _ref9.commit,
        state = _ref9.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].customerCredit(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  customerPointsPaging: function customerPointsPaging(_ref10, data) {
    var commit = _ref10.commit,
        state = _ref10.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_profile_customer__["a" /* default */].customerPointsPaging(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var mutations = {
  updateField: __WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__["d" /* updateField */],
  setAddressList: function setAddressList(state, res) {
    if (state.selectedAddress.CustomersAddressId === null || state.selectedAddress.CustomersAddressId === undefined || state.selectedAddress.CustomersAddressId < 1) {
      var defaultAdd = res.Addresses.filter(function (a) {
        return a.IsDefault === true;
      });
      if (defaultAdd != null && defaultAdd.length > 0) {
        state.selectedAddress = defaultAdd[0];
      } else {
        // state.selectedAddress = res.Addresses[0]
      }
    }
    state.addressList = res.Addresses;
  },
  selectAddress: function selectAddress(state, address) {
    state.addressList.map(function (a) {
      a.IsDefault = false;
      return a;
    });
    state.selectedAddress = address;
    state.addressList.filter(function (a) {
      return a.CustomersAddressId === address.CustomersAddressId;
    })[0].IsDefault = true;
  },
  addNewAddress: function addNewAddress(state, res) {
    state.newAddress = {
      CustomersAddressId: 0,
      FullName: '',
      MobileNo: '',
      PostalCode: '',
      UnitNo: '',
      Address: '',
      BuildingName: '',
      IsDefault: false
    };
    res.IsDefault = true;
    state.addressList.push(res);
    state.selectedAddress = res;
  },
  removeAddress: function removeAddress(state, data) {
    var address = state.addressList.filter(function (a) {
      return a.CustomersAddressId === data.CustomersAddressId;
    });
    if (address[0].CustomersAddressId === state.selectedAddress.CustomersAddressId) {
      state.selectedAddress = null;
    }
    if (address !== null && address.length > 0) {
      var index = state.addressList.indexOf(address[0]);
      if (index > -1) {
        state.addressList.splice(index, 1);
      }
    }
  },
  editAddress: function editAddress(state, data) {
    var address = state.addressList.filter(function (a) {
      return a.CustomersAddressId === data.CustomersAddressId;
    });
    if (address !== null) {
      address[0].Address = data.Address;
      address[0].BuildingName = data.BuildingName;
      address[0].CustomersAddressId = data.CustomersAddressId;
      address[0].FullName = data.FullName;
      address[0].IsDefault = data.IsDefault;
      address[0].MobileNo = data.MobileNo;
      address[0].PostalCode = data.PostalCode;
      address[0].UnitNo = data.UnitNo;
    }
  },
  setCustomerInfo: function setCustomerInfo(state, data) {
    state.info = data;
  },
  editCustomerInfo: function editCustomerInfo(state, data) {
    state.info.FullName = data.FullName;
    state.info.Email = data.Email;
    state.info.ContacctNo = data.ContacctNo;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function listAddress() {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerAddresses, null);
}
function _addAddress(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerAddAddress, data);
}
function _editAddress(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerEditAddress, data);
}
function _removeAddress(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerRemoveAddress, data);
}
function _getCustomerInfo() {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerGetInfo, null);
}
function _editCustomerInfo(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerEditInfo, data);
}
function _editCustomerPassword(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerEditPassword, data);
}
function _customerCredit(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerCredit, data);
}
function _customerPointsPaging(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].customerPointsPaging, data);
}
function fetch(urlString, data) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: urlString,
      data: data,
      dataType: 'json'
    }).then(function (response) {
      resolve(response);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getAddressList: function getAddressList() {
    return listAddress();
  },
  addAddress: function addAddress(data) {
    return _addAddress(data);
  },
  editAddress: function editAddress(data) {
    return _editAddress(data);
  },
  removeAddress: function removeAddress(data) {
    return _removeAddress(data);
  },
  getCustomerInfo: function getCustomerInfo() {
    return _getCustomerInfo();
  },
  editCustomerInfo: function editCustomerInfo(data) {
    return _editCustomerInfo(data);
  },
  editCustomerPassword: function editCustomerPassword(data) {
    return _editCustomerPassword(data);
  },
  customerCredit: function customerCredit(data) {
    return _customerCredit(data);
  },
  customerPointsPaging: function customerPointsPaging(data) {
    return _customerPointsPaging(data);
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_cart___ = __webpack_require__(197);





// initial state
// shape: [{ id, quantity }]
var state = {
  items: {
    CartsProducts: []
  },
  firstItemCheck: false,
  changingDelivery: false,
  tmpProduct: null,
  tokenId: '',
  preAdd: {}

  // getters
};var getters = {
  getField: __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["a" /* getField */],
  isFirstItem: function isFirstItem(state, getters) {
    return state.firstItemCheck;
  },
  tokenId: function tokenId(state, getters) {
    var t = state.tokenId;
    if (t !== null && t !== undefined && t !== '') {
      return t;
    }

    if (process.browser) {
      return localStorage.getItem('tokenId');
    } else {
      return t;
    }
  }

  // actions
};var actions = {
  getCarts: function getCarts(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].getCarts().then(function (res) {
        commit('setCartItems', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  clearCart: function clearCart(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit;

    commit('clearCart');
  },
  noneFirstItem: function noneFirstItem(_ref3, data) {
    var state = _ref3.state,
        commit = _ref3.commit;

    if (data) {
      this.dispatch('cart/cartPreAdd');
    }
    commit('setFirstItem', data);
  },
  changDelivery: function changDelivery(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit;

    this.dispatch('cart/noneFirstItem', true);
    commit('setChangingDelivery', true);
  },
  editDeliveryType: function editDeliveryType(_ref5, data) {
    var _this = this;

    var state = _ref5.state,
        commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].changeDelivery(data).then(function (res) {
        _this.dispatch('cart/noneFirstItem', false);
        return _this.dispatch('cart/getCarts');
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  addProductToCart: function addProductToCart(_ref6, product) {
    var _this2 = this;

    var state = _ref6.state,
        commit = _ref6.commit;

    if (product.IsQuickOrder === null || product.IsQuickOrder === undefined) {
      product.IsQuickOrder = false;
    }
    if (state.items.CartsProducts == null || state.items.CartsProducts.length < 1) {
      this.dispatch('cart/noneFirstItem', true);
      commit('setTmpProduct', product);
    } else {
      this.dispatch('cart/noneFirstItem', false);
      commit('setTmpProduct', null);
      __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].addCart(product).then(function (res) {
        return _this2.dispatch('cart/getCarts');
      });
    }
  },
  addNewCart: function addNewCart(_ref7, data) {
    var _this3 = this;

    var state = _ref7.state,
        commit = _ref7.commit;

    if (state.changingDelivery) {
      return this.dispatch('cart/editDeliveryType', data);
    } else {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].addNew(data).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].addCart(state.tmpProduct).then(function (res) {
            return _this3.dispatch('cart/getCarts');
          });
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },
  cartPreAdd: function cartPreAdd(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].preAdd().then(function (res) {
        commit('setPreAdd', res);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  removeCartProduct: function removeCartProduct(_ref9, data) {
    var _this4 = this;

    var state = _ref9.state,
        commit = _ref9.commit;

    var product = {
      CartsProductId: data.CartsProductId
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].remove(product).then(function (res) {
        return _this4.dispatch('cart/getCarts');
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editCart: function editCart(_ref10, data) {
    var state = _ref10.state,
        commit = _ref10.commit;

    var product = {
      CartsProductId: data.CartsProductId,
      Qty: data.Qty
    };
    var cartItem = state.items.CartsProducts.find(function (item) {
      return item.CartsProductId === data.CartsProductId;
    });
    if (cartItem.Qty === 1 && data.Qty === 1) {
      commit('setProductQty', product);
    } else {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].edit(product).then(function (res) {
          commit('setProductQty', product);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },
  checkout: function checkout(_ref11, data) {
    var _this5 = this;

    var state = _ref11.state,
        commit = _ref11.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_cart___["a" /* default */].checkout(data).then(function (res) {
        if (process.browser) {
          localStorage.removeItem('tokenId');
        }
        _this5.dispatch('cart/generateTokenId');
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  generateTokenId: function generateTokenId(_ref12) {
    var state = _ref12.state,
        commit = _ref12.commit;

    if (process.browser) {
      var ti = localStorage.getItem('tokenId');
      if (ti === undefined || ti === null) {
        var t = 'xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/x/g, function (c) {
          var r = Math.random() * 16 | 0;
          return r.toString(16);
        });
        commit('setTokenId', t);
      }
    }
  }
};

// mutations
var mutations = {
  updateField: __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["d" /* updateField */],
  setFirstItem: function setFirstItem(state, isFirst) {
    state.firstItemCheck = isFirst;
    state.changingDelivery = false;
  },
  setPreAdd: function setPreAdd(state, res) {
    state.preAdd = res;
  },
  clearCart: function clearCart(state) {
    state.items = {
      CartsProducts: []
    };
  },
  setTmpProduct: function setTmpProduct(state, product) {
    state.tmpProduct = product;
  },
  setProductQty: function setProductQty(state, data) {
    var cartItem = state.items.CartsProducts.find(function (item) {
      return item.CartsProductId === data.CartsProductId;
    });
    cartItem.Qty = data.Qty;
    cartItem.SubTotal = cartItem.Qty * cartItem.Price;
    var totalPrice = state.items.CartsProducts.map(function (a) {
      return a.SubTotal;
    }).reduce(function (prev, curr, idx, arr) {
      return prev + curr;
    });
    state.items.SubTotal = totalPrice;
    if (state.items.SubTotal < state.items.FreeDeliveryPurchaseAmount) {
      if (state.items.DeliveryType === 1) {
        state.items.DeliveryFee = state.items.StandardDeliveryFee;
      } else {
        state.items.DeliveryFee = 0;
      }
      state.items.Total = state.items.SubTotal + state.items.DeliveryFee;
    } else {
      state.items.Total = state.items.SubTotal;
    }
    if (state.items.EnableCashPoints === true) {
      var p = state.items.CashPoints !== null ? state.items.CashPoints : 0;
      state.items.WillEarnPoints = Math.round(state.items.SubTotal * p / 100 * 10) / 10;
    }
  },
  setChangingDelivery: function setChangingDelivery(state, data) {
    state.changingDelivery = data;
  },
  setCartItems: function setCartItems(state, items) {
    state.items = items;
  },
  setTokenId: function setTokenId(state, t) {
    if (process.browser) {
      localStorage.setItem('tokenId', t);
    }
    state.tokenId = t;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function _getCarts() {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].carts, null);
}
function _preAdd() {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].cartPreAdd, null);
}
function _addNew(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].cartAddNew, data);
}
function _addCart(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].cartAdd, data);
}
function _remove(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].cartRemove, data);
}
function _edit(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].cartEdit, data);
}
function _checkout(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].cartCheckout, data);
}
function _changeDelivery(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].cartChangeDelivery, data);
}

function fetch(urlString, data) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: urlString,
      data: data,
      dataType: 'json'
    }).then(function (response) {
      resolve(response);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getCarts: function getCarts() {
    return _getCarts();
  },
  preAdd: function preAdd() {
    return _preAdd();
  },
  addNew: function addNew(data) {
    return _addNew(data);
  },
  addCart: function addCart(data) {
    return _addCart(data);
  },
  remove: function remove(data) {
    return _remove(data);
  },
  edit: function edit(data) {
    return _edit(data);
  },
  checkout: function checkout(data) {
    return _checkout(data);
  },
  changeDelivery: function changeDelivery(data) {
    return _changeDelivery(data);
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_order___ = __webpack_require__(199);





// initial state
// shape: [{ id, quantity }]
var state = {
  checkoutInfo: {}

  // getters
};var getters = {
  getField: __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["a" /* getField */]

  // actions
};var actions = {
  getCheckoutInfo: function getCheckoutInfo(_ref, id) {
    var commit = _ref.commit;

    var data = {
      OrderId: parseInt(id)
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].getCheckoutInfo(data).then(function (res) {
        commit('setCheckoutInfo', res);
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  applyVoucher: function applyVoucher(_ref2, data) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].applyVoucher(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  changeDeliveryDate: function changeDeliveryDate(_ref3, data) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].changeDeliveryDate(data).then(function () {
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  complete: function complete(_ref4, data) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].complete(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  thankyou: function thankyou(_ref5, data) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].thankyou(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getList: function getList(_ref6, data) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].getList(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getDetail: function getDetail(_ref7, data) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].getDetail(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  removeOrder: function removeOrder(_ref8, data) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].remove(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  cancelRequest: function cancelRequest(_ref9) {
    var commit = _ref9.commit;

    __WEBPACK_IMPORTED_MODULE_2__api_order___["a" /* default */].cancelRequest();
  }
};

// mutations
var mutations = {
  updateField: __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["d" /* updateField */],
  setCheckoutInfo: function setCheckoutInfo(state, detail) {
    state.checkoutInfo = detail;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__(6);




function _getCheckoutInfo(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].orderCheckoutInfo, data);
}
function _getDetail(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].orderDetail, data);
}
function _applyVoucher(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].orderApplyVoucher, data);
}
function _complete(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].orderComplete, data);
}
function _thankyou(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].orderThankyou, data);
}
function _getList(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].orderGetPaging, data);
}
function _remove(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].orderRemove, data);
}
var cancelToken = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken;
var source = cancelToken.source();
function fetch(urlString, data) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'POST',
      url: urlString,
      data: data,
      dataType: 'json',
      cancelToken: source.token
    }).then(function (response) {
      resolve(response);
    }).catch(function (a) {});
  });
}
function _cancelRequest() {
  source.cancel('cancel');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getCheckoutInfo: function getCheckoutInfo(data) {
    return _getCheckoutInfo(data);
  },
  getDetail: function getDetail(data) {
    return _getDetail(data);
  },
  applyVoucher: function applyVoucher(data) {
    return _applyVoucher(data);
  },
  complete: function complete(data) {
    return _complete(data);
  },
  thankyou: function thankyou(data) {
    return _thankyou(data);
  },
  getList: function getList(data) {
    return _getList(data);
  },
  remove: function remove(data) {
    return _remove(data);
  },
  cancelRequest: function cancelRequest() {
    _cancelRequest();
  },
  changeDeliveryDate: function changeDeliveryDate(data) {
    return fetch(__WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* default */].orderUpdateDelivery, data);
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_customize__ = __webpack_require__(201);


// initial state
var state = {
  all: {}

  // getters
};var getters = {
  finished: function finished(state) {
    var result = state.all.sections.find(function (tmp) {
      return tmp.selected.length === 0;
    }) == null && state.all.name !== '' && state.all.quantity > 0;
    return result;
  }

  // actions
};var actions = {
  getAllCusmoizes: function getAllCusmoizes(_ref) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_customize__["a" /* default */].getCusmoizes(function (customizes) {
      commit('setCusmoizes', customizes);
    });
  },
  itemSelect: function itemSelect(_ref2, item) {
    var state = _ref2.state,
        commit = _ref2.commit;

    var tmpItem = state.all.sections.find(function (tmp) {
      return tmp.id === item.parentid;
    });
    if (tmpItem != null) {
      commit('setSelectedItem', item);
    }
  },
  changeQuantity: function changeQuantity(_ref3, status) {
    var state = _ref3.state,
        commit = _ref3.commit;

    commit('changeQuantity', status);
  },
  changeName: function changeName(_ref4, input) {
    var state = _ref4.state,
        commit = _ref4.commit;

    commit('setName', input.target.value);
  }
};

// mutations
var mutations = {
  setCusmoizes: function setCusmoizes(state, customizes) {
    state.all = customizes;
  },
  setSelectedItem: function setSelectedItem(state, item) {
    var section = state.all.sections.find(function (tmp) {
      return tmp.id === item.parentid;
    });
    if (section != null) {
      if (item.icon === '') {
        section.selected = [item.id];
      } else {
        var nonItem = section.items.find(function (tmp) {
          return tmp.icon === '';
        });
        if (nonItem != null && item.id !== nonItem.id) {
          var nonIndex = section.selected.indexOf(nonItem.id);
          if (nonIndex > -1) {
            section.selected.splice(nonIndex, 1);
          }
        }
        if (section.multi > 0) {
          var index = section.selected.indexOf(item.id);
          if (index > -1) {
            section.selected.splice(index, 1);
          } else {
            if (section.selected.length >= section.multi) {
              section.selected.splice(0, 1);
            }
            section.selected.push(item.id);
          }
        } else if (section.multi === 0) {
          var _index = section.selected.indexOf(item.id);
          if (_index > -1) {
            section.selected.splice(_index, 1);
          } else {
            section.selected.push(item.id);
          }
        }
      }
    }
  },
  changeQuantity: function changeQuantity(state, status) {
    if (status > 0) {
      state.all.quantity += 1;
    } else {
      if (state.all.quantity === 1) {
        state.all.quantity = 1;
      } else {
        state.all.quantity -= 1;
      }
    }
  },
  setName: function setName(state, newValue) {
    state.all.name = newValue;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _cusmoize = {
  'name': '',
  'quantity': 1,
  'sections': [{
    'id': 1,
    'label': 'BREAD',
    'multi': 1,
    'selected': [],
    'items': [{
      'id': 1,
      'parentid': 1,
      'icon': '../../static/img/MenuOptions/bread/img-bread-italian.png',
      'name': 'Italian'
    }, {
      'id': 2,
      'parentid': 1,
      'icon': '../../static/img/MenuOptions/bread/img-bread-heartyitalian.png',
      'name': 'Hearty Italian'
    }, {
      'id': 3,
      'parentid': 1,
      'icon': '../../static/img/MenuOptions/bread/img-bread-wheat.png',
      'name': 'Multi Grain'
    }, {
      'id': 4,
      'parentid': 1,
      'icon': '../../static/img/MenuOptions/bread/img-bread-oats.png',
      'name': 'Honey Oats'
    }, {
      'id': 5,
      'parentid': 1,
      'icon': '../../static/img/MenuOptions/bread/img-bread-oregano.png',
      'name': 'Parmesan Oregano'
    }, {
      'id': 6,
      'parentid': 1,
      'icon': '../../static/img/MenuOptions/bread/img-bread-flatbread.png',
      'name': 'Flat Bread'
    }]
  }, {
    'id': 2,
    'label': 'VEGGIE',
    'multi': 0,
    'selected': [],
    'items': [{
      'id': 1,
      'parentid': 2,
      'icon': '../../static/img/MenuOptions/veggie/img-lettuce.png',
      'name': 'Lettuce'
    }, {
      'id': 2,
      'parentid': 2,
      'icon': '../../static/img/MenuOptions/veggie/img-tomatoes.png',
      'name': 'Tomatoes'
    }, {
      'id': 3,
      'parentid': 2,
      'icon': '../../static/img/MenuOptions/veggie/img-onions.png',
      'name': 'Onions'
    }, {
      'id': 4,
      'parentid': 2,
      'icon': '../../static/img/MenuOptions/veggie/img-pickles.png',
      'name': 'Pickles'
    }, {
      'id': 5,
      'parentid': 2,
      'icon': '../../static/img/MenuOptions/veggie/img-cucumber.png',
      'name': 'Cucumber'
    }, {
      'id': 6,
      'parentid': 2,
      'icon': '../../static/img/MenuOptions/veggie/img-capsicum.png',
      'name': 'Capsicum'
    }, {
      'id': 7,
      'parentid': 2,
      'icon': '../../static/img/MenuOptions/veggie/img-black-olives-sliced.png',
      'name': 'Olives'
    }, {
      'id': 8,
      'parentid': 2,
      'icon': '../../static/img/MenuOptions/veggie/img-jalapeno.png',
      'name': 'Jalapenos'
    }, {
      'id': 9,
      'parentid': 2,
      'icon': '',
      'name': 'No Veggie'
    }]
  }, {
    'id': 3,
    'label': 'SAUCES',
    'multi': 2,
    'selected': [],
    'items': [{
      'id': 1,
      'parentid': 3,
      'icon': '../../static/img/MenuOptions/sauces/img_Caesar.png',
      'name': 'Caesar'
    }, {
      'id': 2,
      'parentid': 3,
      'icon': '../../static/img/MenuOptions/sauces/img_Chipotle.png',
      'name': 'Chipotle'
    }, {
      'id': 3,
      'parentid': 3,
      'icon': '../../static/img/MenuOptions/sauces/img_HoneyMustard.png',
      'name': 'Honey Mustart'
    }, {
      'id': 4,
      'parentid': 3,
      'icon': '../../static/img/MenuOptions/sauces/img_Ketchup.png',
      'name': 'Ketchup'
    }, {
      'id': 5,
      'parentid': 3,
      'icon': '../../static/img/MenuOptions/sauces/img_Mayo.png',
      'name': 'Mayo'
    }, {
      'id': 6,
      'parentid': 3,
      'icon': '../../static/img/MenuOptions/sauces/img_Mustard.png',
      'name': 'Mustard'
    }, {
      'id': 7,
      'parentid': 3,
      'icon': '../../static/img/MenuOptions/sauces/img_SweetOnion.png',
      'name': 'Sweet Onion'
    }, {
      'id': 8,
      'parentid': 3,
      'icon': '',
      'name': 'No Sauces'
    }]
  }]
};
/* harmony default export */ __webpack_exports__["a"] = ({
  getCusmoizes: function getCusmoizes(cb) {
    cb(_cusmoize);
  }
});

/***/ }),
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(204);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(21)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js??ref--8-2!./semantic.min.css", function() {
		var newContent = require("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js??ref--8-2!./semantic.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(206);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(21)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../vue-style-loader/index.js!../../css-loader/index.js??ref--8-2!./flatpickr.css", function() {
		var newContent = require("!!../../extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../vue-style-loader/index.js!../../css-loader/index.js??ref--8-2!./flatpickr.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(208);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(21)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--8-2!./swiper.css", function() {
		var newContent = require("!!../../../extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--8-2!./swiper.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(210);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(21)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--8-2!./sprite.css", function() {
		var newContent = require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--8-2!./sprite.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(212);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(21)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--10-2!../../../node_modules/less-loader/dist/cjs.js??ref--10-3!./site.less", function() {
		var newContent = require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--10-2!../../../node_modules/less-loader/dist/cjs.js??ref--10-3!./site.less");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[84]);


// WEBPACK FOOTER //
// static/js/app.js?v=1698631571653